// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  error: null,
};
const PlanningTagReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ALL_PLANNING_TAG":
      return {
        ...state,
        allData: action.allData,
        data: action.data,
        total: action.totalPages,
      };
    case "GET_PLANNING_TAG":
      return {
        ...state,
        allData: action.allData,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        info: action.info,
      };
    case "EMPTY_ERROR":
    case "ADD_PLANNING_TAG_SUCCESS":
    case "EDIT_PLANNING_TAG_SUCCESS":
      return { ...state, error: null };
    case "ADD_PLANNING_TAG_FAIL":
    case "EDIT_PLANNING_TAG_FAIL":
      return { ...state, error: action.payload };
    default:
      return { ...state };
  }
};

export default PlanningTagReducer;
